import {Component, signal, OnInit, inject} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {OidcSecurityService} from './lib/angular-auth-oidc-client-facade';
import {environment} from '../environments/environment';
import {PrimeNG} from 'primeng/config';
import {TitleService} from '@services/title.service';
import {RegionManagerService} from '@components/openstreetmap/managers/region-manager.service';
import {AppLanguageManager} from '@components/select-language/app-language-manager';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: false,
  styleUrl: './app.css'
})
export class App implements OnInit {
  protected readonly title = signal('Masofa.Client.Angular');
  private readonly oidcSecurityService = inject(OidcSecurityService);

  constructor(
    private translate: TranslateService,
    private languageManager : AppLanguageManager,
    private router: Router,
    private primeng: PrimeNG,
    private titleService: TitleService,
  ) {
    languageManager.initialize();

    this.titleService.setTitle(environment.appName);
    const langs = environment.langs;
    languageManager.onChange.subscribe((newLang:any) => {})
    this.router.config.forEach((route, index) => {
      if (route.children) {
        route.children.forEach((child, childIndex) => {
        });
      }
    });

    translate.addLangs(langs.map(lang => lang.value));
    translate.setDefaultLang(environment.defaultLang);

    const savedLang = localStorage.getItem('lang');

    const browserLang = translate.getBrowserLang();
    const langMap = langs.reduce((acc: { [key: string]: string }, lang) => {
      // @ts-ignore
      acc[lang.iso] = lang.value;
      return acc;
    }, {} as { [key: string]: string });

    if (savedLang && translate.getLangs().includes(savedLang)) {
      translate.use(savedLang);
      this.setPrimeNGLocale(savedLang);
      this.setDirectionForLanguage(savedLang);
    } else if (browserLang && langMap[browserLang]) {
      translate.use(langMap[browserLang]);
      this.setPrimeNGLocale(langMap[browserLang]);
      this.setDirectionForLanguage(langMap[browserLang]);
    } else {
      translate.use(environment.defaultLang);
      this.setPrimeNGLocale(environment.defaultLang);
      this.setDirectionForLanguage(environment.defaultLang);
    }

    translate.onLangChange.subscribe(lang => {
      this.setPrimeNGLocale(lang.lang);
      this.setDirectionForLanguage(lang.lang);
    });

  }

  ngOnInit() {
    if (window.location.pathname === '/callback') {
      return;
    }

  }

  private setPrimeNGLocale(lang: string) {
    this.translate.getTranslation(lang).subscribe(translations => {
      const primeNGTranslations: any = {
        firstDayOfWeek: 0,
        dayNames: [],
        dayNamesShort: [],
        dayNamesMin: [],
        monthNames: [],
        monthNamesShort: [],
        today: 'Today',
        clear: 'Clear',
        emptyMessage: 'No data'
      };

      Object.keys(translations).forEach(key => {
        if (key.startsWith('primeng.')) {
          const primeKey = key.replace('primeng.', '');

          if (primeKey.includes('.')) {
            const parts = primeKey.split('.');
            const mainKey = parts[0];
            const index = parts[1];

            if (!primeNGTranslations[mainKey]) {
              primeNGTranslations[mainKey] = [];
            }
            primeNGTranslations[mainKey][parseInt(index)] = translations[key];
          } else {
            primeNGTranslations[primeKey] = translations[key];
          }
        }
      });

      this.primeng.setTranslation(primeNGTranslations);
    });
  }

  private setDirectionForLanguage(lang: string) {
    const dir = lang.toLowerCase() === 'ar-lb' ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', dir);
    document.body.setAttribute('dir', dir);
  }
}
